import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const SheetsDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment SheetsDisplayGridRowDataFragment on Sheet {
  id
  name
  path
  workbook {
    vizportalUrlId
    name
    projectName
    projectVizportalUrlId
    owner {
      domain
      username
      name
    }
  }
}
`;
